app.controller("TimetableIndexController", [
    "$scope", "TimetableService", "$stateParams", "$state", "$http", "$uibModal", "usSpinnerService",
    function ($scope, TimetableService, $stateParams, $state, $http, $uibModal, usSpinnerService) {

    }
]);